(() => {
  const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (motionPreference.matches || !('IntersectionObserver' in window)) return;

  const revealSelector = [
    '.jbp-section-head',
    '.jbp-category-card',
    '.jbp-product-card',
    '.jbp-editorial__image',
    '.jbp-editorial__content',
    '.jbp-gift__content',
    '.jbp-social__intro',
    '.jbp-reel-card',
    '.jbp-review',
    '.jbp-newsletter__inner',
    '.jbp-footer__main'
  ].join(',');

  const revealItems = Array.from(document.querySelectorAll(revealSelector))
    .filter((item) => !item.closest('.jbp-hero'));

  if (!revealItems.length) return;

  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const delayStep = isMobile ? 34 : 55;
  const maximumDelay = isMobile ? 102 : 220;

  const observer = new IntersectionObserver((entries, activeObserver) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      activeObserver.unobserve(entry.target);
    });
  }, {
    rootMargin: '0px 0px -6% 0px',
    threshold: 0.08
  });

  revealItems.forEach((item) => {
    const siblings = Array.from(item.parentElement.children)
      .filter((sibling) => sibling.matches(revealSelector));
    const position = Math.max(siblings.indexOf(item), 0);
    const delay = Math.min(position * delayStep, maximumDelay);

    item.style.setProperty('--jbp-reveal-delay', delay + 'ms');
    item.classList.add('jbp-scroll-reveal');
    observer.observe(item);
  });
})();